<template>
  <v-row justify="center">
    <v-dialog
      style="border-radius: 5px"
      v-model="show"
      persistent
      max-width="600px"
    >
      <custom-modal
        title="Edit Expense "
        @onSubmit="SaveCategory"
        @onClose="close"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer">
          <v-row>
            <v-col cols="8" sm="8" lg="8">
              <v-radio-group v-model="Expense.expense_for" row>
                <v-radio label="Warehouse" value="Warehouse"></v-radio>
                <v-radio label="Room" value="room"></v-radio>
                <v-radio label="Kitchen" value="kitchen"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="4" sm="4" lg="4">
              <ValidationProvider rules="required" name="Datetime">
                <datePickComponent
                  hide-details="auto"
                  slot-scope="{ errors }"
                  v-model="Expense.date"
                  labelname="Date"
                  :error-messages="errors"
                  required
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" lg="12">
              <ValidationProvider
                name="Expense For"
                rules="required"
                hide-details="auto"
              >
                <v-autocomplete
                  slot-scope="{ errors }"
                  outlined
                  hide-details="auto"
                  v-model="Expense.category_id"
                  item-text="name"
                  item-value="id"
                  :items="expenseCategories"
                  :search-input.sync="searchExpense"
                  :loading="expenseLoading"
                  :error-messages="errors"
                  label="Expense For"
                  required
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" v-if="Expense.expense_for == 'Warehouse'">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="warehouse"
              >
                <v-autocomplete
                  outlined
                  hide-details="auto"
                  v-model="Expense.warehouse_id"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  :search-input.sync="searchWarehouse"
                  :loading="warehouseLoading"
                  :error-messages="errors"
                  label="Warehouse"
                  required
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" v-if="Expense.expense_for == 'room'">
              <ValidationProvider rules="required" name="Room">
                <v-autocomplete
                  outlined
                  slot-scope="{ errors }"
                  hide-details="auto"
                  v-model="Expense.room_id"
                  item-text="name"
                  item-value="id"
                  :items="rooms"
                  :search-input.sync="searchRoom"
                  :loading="roomLoading"
                  :error-messages="errors"
                  label="Room"
                  required
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" v-if="Expense.expense_for == 'kitchen'">
              <ValidationProvider rules="required" name="Kitchen">
                <v-autocomplete
                  outlined
                  slot-scope="{ errors }"
                  hide-details="auto"
                  v-model="Expense.kitchen_id"
                  item-text="name"
                  item-value="id"
                  :items="kitchens"
                  :search-input.sync="searchKitchen"
                  :loading="kitchenLoading"
                  :error-messages="errors"
                  label="Kitchen"
                  required
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" sm="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Amount"
                rules="required"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="Expense.amount"
                  label="Amount"
                  auto-grow
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="Description"
              >
                <v-textarea
                  hide-details="auto"
                  :error-messages="errors"
                  required
                  label="Remark"
                  v-model="Expense.remark"
                  outlined
                  rows="3"
                ></v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
import datePickComponent from "../../../components/base/DateComponent";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import FileUpload from "@/components/base/FileUpload";
import CustomModal from "@/components/base/CustomModal";
import * as moment from "moment/moment";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { Expenses } from "@/models/Expenses";
export default {
  data: () => ({
    selectedImages: "",
    dialog: false,
    warehouses: [],
    searchWarehouse: null,
    expenseLoading: false,
    expenseCategories: [],
    ParentProductCategories: [],
    value: [],
    rooms: [],
    kitchens: [],
    options: [],
    isLoading: false,
  }),

  name: "AddCategory",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
     expenseCategory: {
      type: Object,
      default: {},
    },
    Expense: {
      type: Object,
      default: {},
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    FileUpload,
    datePickComponent,
    CustomModal,
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.expenseCategory);
        }
      },
    },
  },
  methods: {
    close() {
      this.show = false;
      this.expenseCategory = new ProductCategory();

      this.$refs.observer.reset();
    },
    async SaveCategory() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.CreateExpense();
      }
    },

    getWarehouseByQuery(query = "") {
      this.warehouseLoading = true;
      this.$store
        .dispatch("warehouse/GetWarehouse", { query: query, status: "active" })
        .then((res) => {
          console.log(res);
          this.warehouses = res;
          this.warehouseLoading = false;
        })
        .catch((err) => {
          this.warehouseLoading = false;
          this.messages = err.data.name;
        });
    },
    async getAllRoom(value) {
      await this.$store
        .dispatch("Kitchen/GetRooms", {})
        .then((res) => {
          this.rooms = res;
        })
        .catch((err) => {});
    },
    async getAllKitchen(value) {
      await this.$store
        .dispatch("Kitchen/GetKitchen", {})
        .then((res) => {
          this.kitchens = res;
        })
        .catch((err) => {});
    },
    getExpenseCategoriesByQuery() {
      this.expenseLoading = true;
      this.$store
        .dispatch("sitesetting/GetExpenseCategories")
        .then((res) => {
          console.log(res);
          this.expenseCategories = res.data.data;
          this.expenseLoading = false;
        })
        .catch((err) => {
          this.expenseLoading = false;
          this.messages = err.data.name;
        });
    },
    CreateExpense() {
      this.isLoading = true;

      this.$store
        .dispatch("warehouse/EditExpense", {
          expense_for: this.Expense.expense_for,
          warehouse_id: this.Expense.warehouse_id,
          room_id: this.Expense.room_id,
          kitchen_id: this.Expense.kitchen_id,
          category_id: this.Expense.category_id,
          amount: this.Expense.amount,
          remark: this.Expense.remark,
          id: this.Expense.id,
          date: this.Expense.date,
        })
        .then(async (res) => {
          this.succeeed = true;
          this.$emit("afterSave");
          this.$toast.success("Expense Edited succesfully");

          this.isLoading = false;
          this.show = false;
          this.$refs.observer.reset();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.data.error);

          this.$toast.error("Expense Edited failed!");
          this.isLoading = false;
        });
    },
  },

  created() {
    this.getExpenseCategoriesByQuery();
    this.getWarehouseByQuery();
    this.getAllRoom("");
    this.getAllKitchen("");
  },
};
</script>
